import './styles.scoped.css'
import {Typography, Button, Modal} from '@mui/material'
import {useGlobalStates} from '../../../../contexts/GlobalStatesContext'
import {adminApi} from '../../../../services'
import {parseError} from '../../../../utils/helpers'

export default ({open, setOpen, organization, payer, onDeleted}) => {
    const {setLoading, setMessageBox} = useGlobalStates()

    const remove = () => {
        setLoading(true)
        adminApi
            .deletePayer(organization?.id, payer?.id)
            .then(() => {
                setLoading(false)
                setOpen(false)
                setMessageBox({
                    status: 'success',
                    title: 'Payor removed',
                    description: `${payer?.payer_name} is no longer available to this organization.`,
                })
                onDeleted?.()
            })
            .catch(error => {
                setLoading(false)
                setOpen(false)
                const {title, description} = parseError(error)
                // A payer on a service agreement cannot be removed; the API says
                // so, and that message is the useful part.
                setMessageBox({
                    status: 'error',
                    title: title || 'Could not remove payor',
                    description: description || 'There was an error removing this payor. Please try again later.',
                })
            })
    }

    return (
        <Modal open={open}>
            <div className="container">
                <div className="content">
                    <div className="title">
                        <Typography variant="h6" color="text.primary">
                            {`Remove ${payer?.payer_name} from ${organization?.name}`}
                        </Typography>
                    </div>
                    <br />
                    <Typography variant="body2" color="text.primary" style={{textAlign: 'center'}}>
                        This organization's branches will no longer be able to bill this payor. A payor already used on a service agreement cannot be
                        removed.
                    </Typography>
                    <br />
                    <div className="actions">
                        <Button variant="outlined" fullWidth onClick={() => setOpen(false)}>
                            Cancel
                        </Button>
                        <Button variant="contained" fullWidth color="error" onClick={remove}>
                            Remove Payor
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
